import Vue from 'vue';
import VueI18n from 'vue-i18n';
import csMessages from '@/lang/cs';
import enMessages from '@/lang/en';
import axios from 'axios';
import moment from 'moment';
import flatpickr from 'flatpickr';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: {
    ...csMessages,
    ...enMessages,
  },
});

const loadedLanguages = ['cs', 'en']; // our default language that is preloaded
const flatPickrLangsMapping = {
  cs: flatpickr.l10ns.cs,
  en: flatpickr.l10ns.en,
};

function setI18nLanguage(lang) {
  i18n.locale = lang;
  moment.locale(lang);
  axios.defaults.headers.common['Accept-Language'] = lang;
  flatpickr.localize(flatPickrLangsMapping[lang] || flatpickr.l10ns.en);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(
        (msgs) => {
          i18n.setLocaleMessage(lang, msgs.default);
          loadedLanguages.push(lang);
          return setI18nLanguage(lang);
        },
      ).catch((error) => {
        console.log(error);
        return Promise.resolve(i18n.locale);
      });
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}
